var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 60,
    viewBox: "0 0 56 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0641 14.159C13.8748 13.2803 15.1892 13.2803 15.9999 14.159L27.6798 26.818L39.3596 14.159C40.1703 13.2803 41.4847 13.2803 42.2954 14.159C43.1062 15.0377 43.1062 16.4623 42.2954 17.341L30.6156 30L42.2954 42.659C43.1062 43.5377 43.1062 44.9623 42.2954 45.841C41.4847 46.7197 40.1703 46.7197 39.3596 45.841L27.6798 33.182L15.9999 45.841C15.1892 46.7197 13.8748 46.7197 13.0641 45.841C12.2534 44.9623 12.2534 43.5377 13.0641 42.659L24.7439 30L13.0641 17.341C12.2534 16.4623 12.2534 15.0377 13.0641 14.159Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDelete);
export default __webpack_public_path__ + "static/media/edit_delete.827d013cd033111e24fd62cef872dd87.svg";
export { ForwardRef as ReactComponent };